"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var icon_1 = __importDefault(require("../../icon"));
function FooterLi(props) {
    var hrefTitle = props.hrefTitle, title1 = props.title1, href = props.href, extendProps = props.extendProps;
    var footLinkColor = props.footLinkColor, footLinkHoverColor = props.footLinkHoverColor;
    var _a = (0, react_1.useState)(false), hover = _a[0], setHover = _a[1];
    return (react_1.default.createElement("li", null,
        react_1.default.createElement("a", __assign({ className: "link-item", href: href || 'javascript:void(0);' }, (extendProps || {}), { onMouseOver: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, style: hover ? { background: footLinkHoverColor } : { background: '#FFF' } }),
            react_1.default.createElement("div", { className: "item-title" },
                react_1.default.createElement("span", { className: "title", style: footLinkColor ? { color: footLinkColor } : {} }, hrefTitle),
                react_1.default.createElement("span", { className: "title1" }, title1)),
            react_1.default.createElement(icon_1.default, { name: "arrow-right", size: 14, color: footLinkColor }))));
}
exports.default = FooterLi;
//# sourceMappingURL=FooterLi.js.map